import { appMessages } from "./app";
import { reviewsMessages } from "./reviews";
import { standardsMessages } from "./standards";
import { reviewSubmissionMessages } from "./reviewSubmission";
import { rulesMessages } from "./rules";
import { administrationMessages } from "./administration";
import { targetingMessages } from "./targeting";
import { systemGuideMessages } from "./systemGuide";
import { educateSageMessages } from "./educateSage";
import { supportMessages } from "./support";
import { askSageMessages } from "./askSage";
import { aiQualityMessages } from "./aiQuality";

export const messageGroups = [
  appMessages,
  reviewsMessages,
  standardsMessages,
  reviewSubmissionMessages,
  rulesMessages,
  administrationMessages,
  targetingMessages,
  systemGuideMessages,
  educateSageMessages,
  supportMessages,
  askSageMessages,
  aiQualityMessages,
] as const;

export const messages = {
  ...appMessages,
  ...reviewsMessages,
  ...standardsMessages,
  ...reviewSubmissionMessages,
  ...rulesMessages,
  ...administrationMessages,
  ...targetingMessages,
  ...systemGuideMessages,
  ...educateSageMessages,
  ...supportMessages,
  ...askSageMessages,
  ...aiQualityMessages,
};

export type MsgKey = keyof typeof messages;
